import React from 'react';
import styled from 'styled-components';
import ChevronDownIcon from 'assets/chevron-down';

interface DropdownCaretProps {
  readonly className?: string;
  readonly open: boolean;
  readonly scale?: number;
}

const DropdownCaret = ({
  className,
  open,
  scale = 0.7,
}: DropdownCaretProps) => (
  <Caret aria-hidden="true" className={className} data-open={open}>
    <ChevronDownIcon scale={scale} />
  </Caret>
);

export default DropdownCaret;

const Caret = styled.span`
  align-items: center;
  display: inline-flex;
  transition: transform 160ms ease;

  &[data-open='true'] {
    transform: rotate(180deg);
  }
`;
